/*
 * Resumo de valores do carrinho.
 *
 * Só faz uma coisa: delegar o clique dos botões de expandir das linhas de frete
 * e de cupom. Subtotal, desconto e total vêm prontos do Liquid — no Dawn o
 * servidor re-renderiza o rodapé a cada mutação do carrinho, então não há por
 * que manter um estado observável repintando esses nós.
 */

class CartSummary extends HTMLElement {
  connectedCallback() {
    this.onClick = this.handleToggle.bind(this);
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  handleToggle(event) {
    const toggle = event.target.closest('.cart-summary__toggle');
    if (!toggle || !this.contains(toggle)) return;

    const dropdown = toggle.closest('.cart-summary__row')?.querySelector('.cart-summary__dropdown');
    if (!dropdown) return;

    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isExpanded));
    dropdown.toggleAttribute('open', !isExpanded);
  }
}

customElements.define('cart-summary', CartSummary);
